import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { GroupTreesState } from './types'

const INITIAL_STATE: GroupTreesState = {
  error: '',
  list: [],
  loading: false,
  sendGroupTreesError: '',
  sendGroupTreesLoading: false,
  total_results: 0
}

const reducer = createReducer<GroupTreesState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getGroupTrees, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getGroupTreesFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getGroupTreesSuccess, (state, { payload }) => ({
    ...state,
    list: payload,
    loading: false,
    total_results: payload.length
  }))
  .handleAction(Actions.sendGroupTrees, state => ({
    ...state,
    sendGroupTreesError: '',
    sendGroupTreesLoading: true
  }))
  .handleAction(Actions.sendGroupTreesFailure, (state, { payload }) => ({
    ...state,
    sendGroupTreesError: payload.message,
    sendGroupTreesLoading: false
  }))
  .handleAction(Actions.sendGroupTreesSuccess, state => ({
    ...state,
    sendGroupTreesLoading: false
  }))

export default reducer
